import Vue from 'vue';

Vue.filter('asHour', (time) => time.format('HH:mm'));
